import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { HeaderEnum } from "./constant";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import SearchTabs from "@frameworks/web/components/Search/SearchTabs";
import EdModalSearchBar from "@frameworks/web/components/generic/EdModalSearchBar";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import transactmenu from "@frameworks/web/assets/images/headerDesk/Reports/transactmenu.svg";
const TransactContent = (props) => {
    const device = DeviceContext();
    const navigate = useNavigate();
    const [index, setIndex] = useState(0);
    const [searchPop, setSearchPop] = React.useState(false);
    const hidenavTab = () => {
        props.setShowNav(() => !props.showNav);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "mx-0" },
            React.createElement(Col, { lg: 12, className: "px-0 transact-content-section" },
                React.createElement("div", { className: "d-space-between" },
                    React.createElement("div", { className: "leftsection-grid  mgt-30" },
                        React.createElement(Row, { className: "mx-0 header-link-section pt-0" },
                            React.createElement(Col, { lg: 12, className: "grid-2 gap-30" },
                                React.createElement("ul", { className: "header-link-content" },
                                    React.createElement("li", null,
                                        React.createElement(Link, { to: "", onClick: () => {
                                                hidenavTab();
                                                setSearchPop(true);
                                            } }, "Place Order")),
                                    React.createElement("li", null,
                                        React.createElement(Link, { to: HeaderEnum.FUND_TRANSFER, onClick: () => {
                                                hidenavTab();
                                            } }, "Fund Transfer")),
                                    React.createElement("li", null,
                                        React.createElement(Link, { to: HeaderEnum.POSITION, onClick: () => {
                                                hidenavTab();
                                            } }, "Positions")),
                                    React.createElement("li", null,
                                        React.createElement(Link, { to: HeaderEnum.ORDERBOOK, onClick: () => {
                                                hidenavTab();
                                            } }, "Orderbook")),
                                    React.createElement("li", null,
                                        React.createElement(Link, { to: HeaderEnum.SEE_MARGIN, onClick: () => {
                                                hidenavTab();
                                            } }, "See Margin"))),
                                React.createElement("ul", { className: "header-link-content" },
                                    React.createElement("li", null,
                                        React.createElement(Link, { to: HeaderEnum.EDIS, onClick: () => {
                                                hidenavTab();
                                            } }, "Authorize to Sell")),
                                    React.createElement("li", null,
                                        React.createElement(Link, { to: HeaderEnum.PLEDGE, onClick: () => {
                                                hidenavTab();
                                            } }, "Pledge")),
                                    React.createElement("li", null,
                                        React.createElement(Link, { to: HeaderEnum.EVOTING, onClick: () => {
                                                hidenavTab();
                                            } }, "E Voting")),
                                    React.createElement("li", null,
                                        React.createElement(Link, { to: HeaderEnum.MARGIN_FILES, onClick: () => {
                                                hidenavTab();
                                            } }, "Margin Files")))))),
                    React.createElement("div", { className: "rightsection-grid" }, device && device.isDesktop ? (React.createElement(React.Fragment, null,
                        React.createElement(Row, { className: "mx-0 px-3 pb-4 pt-4" },
                            React.createElement(Col, { lg: 12, className: "px-0" },
                                React.createElement("div", null,
                                    React.createElement("span", { className: "aligncenteritem" },
                                        React.createElement("img", { src: transactmenu })),
                                    React.createElement("span", { className: "DMSansMedium_18_500 txt-midnight-blue aligncenteritem mgt-30" }, "New Powerful watchlist"),
                                    React.createElement("span", { className: "DMSanM_14_500 txt_secondary-gray aligncenteritem" },
                                        "Strategize, monitor, and transact with ",
                                        React.createElement("br", null),
                                        " our powerful watchlist, optimizing your ",
                                        React.createElement("br", null),
                                        " portfolio decisions in real-time.")),
                                React.createElement("div", { className: "mgt-20 aligncenteritem" },
                                    React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Go to Watchlist", className: "small-edbutton mb-2", onClick: () => {
                                            navigate("/watchlist");
                                            hidenavTab();
                                        } })))))) : (React.createElement(React.Fragment, null)))))),
        (device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement(EdModalSearchBar, { show: searchPop, modalBodyContent: React.createElement(SearchTabs, { searchData: [], loader: false, error: "", setLoader: undefined, search: "", setSearch: undefined, openOption: false, setOpt: undefined, activeTab: "", setActiveTab: undefined, selectedOption: undefined, serachPopup: undefined }), showFooter: false, footerContent: "", headContent: "", setShow: setSearchPop }))));
};
export default TransactContent;
